import * as React from "react";
var ConfigContext = React.createContext({
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? "lg-" + suffixCls : "lg";
  }
});
var ConfigConsumer = ConfigContext.Consumer;
export { ConfigContext, ConfigConsumer };